export type UserRoleCode = 'super' | 'admin';

export const CLIENT_ROUTE = '/users';
export const API_ROUTE = '/api/user'
export const CLIENT_TITLE = 'Системийн хэрэглэгч'

export const roleCodes: UserRoleCode[] = [
    'admin',
    'super'
]